import React, { FC, useMemo } from 'react';
import styled from 'styled-components/native';

import dynamicSize from '@webtrader/core/dynamic-size';
import { useTheme } from '@webtrader/core/services/theme/v2';

import FaceIdIcon from '@/assets/Login/faceid_icon.svg';
import Button from '@/components/Button';
import MaterialIcons from '@/components/Icons/Material';
import { EBiometricsType } from '@/utils/biometrics';

import { useBiometrics } from './Hooks/useBiometrics';

interface IProps {
  isDemo: boolean;
  loading: boolean;
}

const Biometrics: FC<IProps> = (props) => {
  const { isDemo, loading } = props;
  const { theme } = useTheme();

  const { onBiometricsLoginPress, biometryType, isBiometricEnable } = useBiometrics();

  const biometricsButtonLayout = useMemo(() => {
    if (biometryType === EBiometricsType.NOT_SUPPORT) {
      return null;
    }

    return (
      <BiometricsButton loading={loading} onPress={onBiometricsLoginPress}>
        {biometryType === EBiometricsType.FACE_ID ? (
          <FaceIdIcon />
        ) : (
          <MaterialIcons name="fingerprint" size={32} color={theme.colors.marketNews.text} />
        )}
      </BiometricsButton>
    );
  }, [biometryType, loading, theme, onBiometricsLoginPress]);

  if (!isBiometricEnable || isDemo) {
    return null;
  }

  return biometricsButtonLayout;
};

export default Biometrics;

const BiometricsButton = styled(Button)`
  margin-start: ${dynamicSize.convertSize(10)}px;
  width: ${dynamicSize.convertSize(45)}px;
`;
